import type { TFunctionType } from "@/core/hooks/use-typed-translation";

import { createPreviewActions } from "./create-preview-actions";
import {
  ShareablePreview,
  type ShareablePreviewFeeLine,
} from "./shareable-preview";

/**
 * Dialog de prévisualisation + confirmation pour une mutation HTTP
 * authentifiée **sans** section frais (statut, DELETE logique, PATCH,
 * création / édition de référentiel).
 *
 * Les flux avec frais (guide §9.5) restent sur `ShareablePreview` + props
 * `fees` / `total` — ce helper les accepte aussi si un récap indicatif
 * est pertinent, mais n'en invente pas.
 */
export type MutationConfirmPreviewProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  data: unknown;
  title: string;
  description?: string;
  onConfirm: () => void;
  pending?: boolean;
  /** Traduction pour les labels par défaut de `createPreviewActions`. */
  t?: (key: string) => string;
  confirmLabel?: string;
  fees?: ShareablePreviewFeeLine[];
  total?: ShareablePreviewFeeLine;
};

export function MutationConfirmPreview({
  open,
  onOpenChange,
  data,
  title,
  description,
  onConfirm,
  pending = false,
  t,
  confirmLabel,
  fees,
  total,
}: MutationConfirmPreviewProps) {
  if (!open) return null;

  return (
    <ShareablePreview
      data={data}
      title={title}
      description={description}
      mode="user"
      fees={fees}
      total={total}
      defaultOpen
      onOpenChange={(isOpen) => {
        if (!isOpen && !pending) onOpenChange(false);
      }}
      maxHeight="90vh"
      actions={createPreviewActions({
        onConfirm,
        onCancel: () => onOpenChange(false),
        t: t ? (key: TFunctionType) => t(key) : undefined,
        labels: confirmLabel ? { confirm: confirmLabel } : undefined,
        confirmLoading: pending,
        withIndicatorOnConfirm: true,
      })}
    />
  );
}
